// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39VX1","questions":"styles_questions__J30zI","footer":"styles_footer__1bm5e"};